import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// A patient's eLab laboratory orders, newest first by default (KIN-1390).
// Paginated server-side, so `page`/`rows` go to the backend rather than slicing
// here. A short staleTime because the laboratory's answer arrives on a ~15 minute
// background poller — a five-minute cache would show a settled order as pending.
export const usePatientLabOrders = ({
  patientId,
  page = 1,
  rows = 10,
  sorting = "newest-first",
}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["labOrdersList", patientId, page, rows, sorting],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const orderBy = sorting === "oldest-first" ? "ASC" : "DESC";
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/lab-orders/patient/${patientId}?page=${page}&rows=${rows}&orderBy=${orderBy}`
      );

      // The API envelope is unwrapped by the axios interceptor, leaving the
      // PaginationResponse itself. Note `rowsPerPage`, not `rows`.
      return {
        data: response?.data?.data ?? [],
        totalRecords: response?.data?.totalRecords ?? 0,
        page: response?.data?.page ?? page,
        rowsPerPage: response?.data?.rowsPerPage ?? rows,
      };
    },
    enabled: !!tenantVal && !!patientId,
    staleTime: 1000 * 30,
  });
};
